// (A) addressStore.js
import { defineStore } from "pinia";

export const useAddressStore = defineStore("address", {
  state: () => ({
    selectedAddress: null,
    // 필요하다면 다른 state도 추가
  }),
  actions: {
    setSelectedAddress(addr) {
      this.selectedAddress = addr;
    },
  },
});
